import { useT } from '../../i18n'
import styles from '../note.module.css'

/**
 * Explains what a gateway is, what mapping one does, and — since V1.1 — what
 * the Beneficiaries panel does: the other scope mechanism, for organisations
 * that hold an identity on a gateway rather than the gateway itself.
 *
 * The concept genuinely needs explaining: in Core a gateway is the outbound
 * connector a payment leaves through ("Paid Via Connector"), not the channel
 * the customer paid from, and Core never records which biller owns one — this
 * screen is the only place that relationship exists. Without that context,
 * "Assigned to" reads as bookkeeping when it is actually the visibility
 * boundary: it decides whose users may see the gateway's transactions.
 *
 * Expanded by default, same reasoning as the internal-users note: the person
 * who needs it most is the one arriving for the first time, and they should
 * not have to notice a chevron before assigning an aggregator gateway to a
 * single biller. It remains a <details> so anyone tired of it can fold it.
 */
export function GatewayNote() {
  const t = useT()
  return (
    <details className={styles.note} open>
      <summary className={styles.summary}>{t('gateways.note.title')}</summary>
      <div className={styles.body}>
        <p>{t('gateways.note.what')}</p>
        <p>{t('gateways.note.whatNot')}</p>
        <p>{t('gateways.note.why')}</p>
        <p className={styles.key}>{t('gateways.note.assign')}</p>
        <p className={styles.caution}>{t('gateways.note.caution')}</p>
        <p>{t('gateways.note.beneficiaries')}</p>
        <p>{t('gateways.note.label')}</p>
      </div>
    </details>
  )
}
